// @ts-nocheck
import { ProductAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { AddToCartOptionsAndButtonStyles } from "@store/Library/Components/Toolkit/AddToCartOptionsAndButton";
import PlusCircleFill from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import { TypographyPresentationProps } from "@store/MobiusOverrides/Typography/Typography";
import { ProductAttributesStyles } from "@store/Overrides/Components/ProductAttributes";
import { ProductAvailabilityStyles } from "@store/Overrides/Components/ProductAvailability";
import { ProductBrandStyles } from "@store/Overrides/Components/ProductBrand";
import { ProductDescriptionStyles } from "@store/Overrides/Components/ProductDescription";
import { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import { ProductImageBadgesStyles } from "@store/Overrides/Components/ProductImageBadges";
import { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { ProductQuantityBreakPricingStyles } from "@store/Overrides/Components/ProductQuantityBreakPricing";
import { ProductTextBadgesStyles } from "@store/Overrides/Components/ProductTextBadges";
import { typographyProductNameStyles } from "@store/Themes/common/mixins/typography";
import { attributeSpacing } from "@store/Themes/common/props/attributes";
import { badgeProps } from "@store/Themes/common/props/badge";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// import { spacingStyles } from "@toolkit/Themes/common/mixins"; // Store Custom Code
import { css } from "styled-components";

/* Store Custom Code - Start */
import HeartPlus from "@store/Library/Components/Icons/HeartPlus";
import { linkGetIconOnlyLinkProps } from "@store/Themes/common/props/link";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { spacingStyles } from "@toolkit/Themes/common/mixins";

const productCardPadding = pxToRem(12);
const groupSpacing = pxToRem(10);
const groupItemWrapper: InjectableCss = {
    css: css`
        ${spacingStyles(pxToRem(-14), `calc(${groupSpacing} * 2)`)}
    `,
};
/* Store Custom Code - End */

export interface ProductCardProps {
    card?: InjectableCss;
    spacingWrapper?: InjectableCss;
    brand?: ProductBrandStyles;
    description?: ProductDescriptionStyles;
    image?: ProductImageStyles;
    sponsoredText?: TypographyPresentationProps;
    partNumbers?: ProductPartNumbersStyles;
    attributes?: ProductAttributesStyles;
    availability?: ProductAvailabilityStyles;
    badgeAreaWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    badgeImageWrapper?: InjectableCss;
    textBadges?: ProductTextBadgesStyles;
    imageBadges?: ProductImageBadgesStyles;
    actionsWrapper?: InjectableCss;
    price?: ProductPriceStyles;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    addToCartOptionsAndButton?: AddToCartOptionsAndButtonStyles;
    addToListWrapper?: InjectableCss;
    addToListLink?: ProductAddToListLinkStyles;
    // Store Custom Code
    groupItemWrapper?: InjectableCss;
    padding?: string;
    swatchWrapper?: InjectableCss;
}

const spacingWrapper: InjectableCss = {
    css: css`
        ${x => spacingStyles(0, x.theme.design.product.list.contentSpacing)}
    `,
};

const labelProps: TypographyPresentationProps = {
    variant: "legend",
    css: css`
        ${x => x.theme.typography.legend.css}
    `,
};

export const productCardProps: ProductCardProps = {
    spacingWrapper,
    card: {
        css: css`
            position: relative;
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            background-color: ${getColor("common.background")};
            /* Store Removed - padding */
            border: ${productCardPadding} solid transparent; /* Store Custom Code */
            border-radius: ${x => x.theme.design.common.contentRadius};
        `,
    },
    image: {
        wrapper: {
            css: spacingStyles(null, pxToRem(13)), // Store Custom Code
        },
        linkWrappingImage: {
            css: css`
                max-height: ${pxToRem(360) /* Store Custom Code */};
            `,
        },
    },
    sponsoredText: {
        css: css`
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            font-size: ${x => x.theme.design.typography.size.tiny};
            padding: 0.5em 1em;
            border: ${pxToRem(1)} solid ${getColor("common.border")};
            border-top: 0;
            background: ${getColor("common.background")};
            color: ${getColor("text.accent")};
        `,
    },
    brand: {
        wrapper: {
            ...spacingWrapper,
            css: css`
                ${spacingWrapper.css}
                font-size: ${x => x.theme.design.typography.size.tiny};
            `,
        },
    },
    description: {
        wrapper: {
            ...spacingWrapper,
            forwardAs: "h3",
            css: css`
                ${spacingWrapper.css}
                ${typographyProductNameStyles()}
                font-size: ${x => x.theme.design.typography.size.large /* Store Custom Code */};
            `,
        },
    },
    partNumbers: {
        wrapper: {
            css: spacingStyles(null, attributeSpacing),
        },
    },
    attributes: {
        container: {
            css: spacingStyles(null, attributeSpacing),
        },
    },
    availability: {
        wrapper: groupItemWrapper, // Store Custom Code
        inventoryMessage: {
            css: css`
                /* Store Removed - margin */
            `,
        },
    },
    badgeAreaWrapper: badgeProps.badgeAreaWrapper,
    badgeTextWrapper: badgeProps.badgeTextWrapper,
    badgeText: badgeProps.badgeText,
    badgeImageWrapper: badgeProps.badgeImageWrapper,
    textBadges: {
        tagWrapper: {
            extendedStyles: {
                wrapper: {
                    css: css`
                        ${spacingWrapper.css}
                        padding: ${pxToRem(4, 0)};
                    `,
                },
            },
        },
    },
    imageBadges: {
        flexWrapper: {
            extendedStyles: {
                wrapper: {
                    css: css`
                        ${spacingWrapper.css}
                        width: 100%;
                    `,
                },
            },
        },
    },
    actionsWrapper: {
        css: css`
            ${spacingWrapper.css}
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            flex-grow: 1;
            /* Store Custom Code - Start */
            margin-top: ${groupSpacing};
            /* Store Custom Code - End */
        `,
    },
    price: {
        wrapper: {
            css: css`
                /* Store Removed - padding */
            `,
        },
    },
    quantityBreakPricing: {},
    addToCartOptionsAndButton: {
        flexWrapper: {
            extendedStyles: {
                wrapper: spacingWrapper,
            },
        },
        unitOfMeasure: {
            extendedStyles: {
                // labelProps,
            },
        },
        quantityOrdered: {
            extendedStyles: {
                // labelProps,
            },
        },
    },
    addToListWrapper: {
        /* Store Custom Code - Start */
        css: css`
            position: absolute;
            top: ${pxToRem(10)};
            right: ${pxToRem(10)};
            border-radius: 50%;
        `,
        /* Store Custom Code - End */
    },
    addToListLink: {
        /* Store Custom Code - Start */
        link: mergeProps<ProductAddToListLinkStyles["link"]>(linkGetIconOnlyLinkProps(HeartPlus), {
            css: css`
                svg {
                    position: relative;
                    top: ${pxToRem(1)};
                    left: ${pxToRem(1)};
                }
            `,
        }),
        /* Store Custom Code - End */
    },
    /* Store Custom Code - Start */
    groupItemWrapper,
    padding: productCardPadding,
    swatchWrapper: {
        css: css`
            ${spacingWrapper.css}
            display: flex;
            flex-direction: column;
        `,
    },
    /* Store Custom Code - End */
};
